import Vue from 'vue';
import Paginate from 'vuejs-paginate/src/components/Paginate.vue';

Vue.component('paginate', Paginate);
